var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#e7c353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.65 17.2a.428.428 0 01-.346-.393l-.55-8.401a.428.428 0 01.614-.415l7.584 3.658a.429.429 0 01-.106.807l-4.354.83-2.4 3.726a.428.428 0 01-.443.188z"
  }))));
};
export default SvgDiscover;